// extracted by mini-css-extract-plugin
export default {"tooltip":"styles_tooltip__kYfSu","tooltipTitle":"styles_tooltipTitle__8SXcB","activatedUser":"styles_activatedUser__WoXXR","deactivatedUser":"styles_deactivatedUser__m0NYZ"};